var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.ready)?_c('div',[(_vm.loading)?_c('b-spinner'):_vm._e(),(!_vm.loading)?_c('scrollable-table',{attrs:{"items":_vm.groupedItems}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }